import React from 'react';
import { palette } from '../../style-utils/theme';

interface ThreeDotsProps {
  color?: string;
}

/* DECORATION. This glyph always sits beside its own text label, so
   exposing it to the accessibility tree only adds a nameless graphic
   before every button that uses it. */
export const ThreeDots: React.FC<ThreeDotsProps> = ({
  color = palette.ink,
}) => {
  return (
    <svg
      aria-hidden="true"
      focusable="false"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <circle
        cx="12"
        cy="12"
        r="1"
        stroke={color}
        strokeWidth="2"
        strokeLinecap="round"
      />
      <circle
        cx="6"
        cy="12"
        r="1"
        stroke={color}
        strokeWidth="2"
        strokeLinecap="round"
      />
      <circle
        cx="18"
        cy="12"
        r="1"
        stroke={color}
        strokeWidth="2"
        strokeLinecap="round"
      />
    </svg>
  );
};
